import React from 'react';
import { getUpcomingMarketDates } from '../config/marketDates';
import './MarketDates.css';

const MarketDates = () => {
  const upcomingDates = getUpcomingMarketDates();

  if (upcomingDates.length === 0) {
    return null; // Don't show the section if there are no upcoming dates
  }

  return (
    <section id="market-dates" className="market-dates-section">
      <div className="market-dates-container">
        <div className="market-dates-header">
          <p className="market-dates-subtitle">Where to find us</p>
        </div>
        
        <div className="market-dates-grid">
          {upcomingDates.map((item, index) => (
            <div key={index} className="market-date-card">
              <div className="market-date-calendar">
                <span className="market-date-day">{item.date.split(' ')[0]}</span>
                <span className="market-date-month">{item.date.split(' ')[1]}</span>
              </div>
              <div className="market-date-info">
                <h3 className="market-event">{item.event}</h3>
                <div className="market-details">
                  <div className="market-time">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                      <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    {item.time}
                  </div>
                  {item.loc && (
                    <div className="market-location">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                        <path d="M12 21C12 21 5 14.5 5 9.5C5 5.35786 8.13401 2 12 2C15.866 2 19 5.35786 19 9.5C19 14.5 12 21 12 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <circle cx="12" cy="9.5" r="3" stroke="currentColor" strokeWidth="2"/>
                      </svg>
                      {item.loc}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MarketDates;
